export const REGISTRATION_CLASSES = [
  { value: "registered", label: "Fully registered" },
  { value: "qualifying", label: "Qualifying / in training" },
];

const ONTARIO_COLLEGES = [
  {
    code: "CNO",
    name: "College of Nurses of Ontario",
    registerUrlTemplate: null,
    searchUrl: "https://registry.cno.org/Search/Search",
    enabled: true,
  },
  {
    code: "CPSO",
    name: "College of Physicians and Surgeons of Ontario",
    registerUrlTemplate: null,
    searchUrl: "https://register.cpso.on.ca/",
    enabled: true,
  },
  {
    code: "OCP",
    name: "Ontario College of Pharmacists",
    registerUrlTemplate: null,
    searchUrl: "https://members.ocpinfo.com/tcpr/public/pr/en/",
    enabled: true,
  },
  {
    code: "CPSOPA",
    name: "CPSO Physician Assistant register",
    registerUrlTemplate: null,
    searchUrl: "https://paregister.cpso.on.ca/",
    enabled: true,
  },
  {
    code: "RCDSO",
    name: "Royal College of Dental Surgeons of Ontario",
    registerUrlTemplate: null,
    searchUrl: "https://www.rcdso.org/en-ca/find-a-dentist",
    enabled: true,
  },
  {
    code: "CDHO",
    name: "College of Dental Hygienists of Ontario",
    registerUrlTemplate: null,
    searchUrl: "https://publicregister.cdho.org/en-US/",
    enabled: true,
  },
  {
    code: "CDO",
    name: "College of Denturists of Ontario",
    registerUrlTemplate: null,
    searchUrl: "https://denturists-cdo.com/Protecting-the-Public/Find-A-Denturist.aspx",
    enabled: true,
  },
  {
    code: "CPO",
    name: "College of Physiotherapists of Ontario",
    registerUrlTemplate: null,
    searchUrl: "https://publicregister.collegept.org/",
    enabled: true,
  },
  {
    code: "COTO",
    name: "College of Occupational Therapists of Ontario",
    registerUrlTemplate: null,
    searchUrl: "https://otportal.coto.org/Public-Register-Search-Custom/",
    enabled: true,
  },
  {
    code: "CMTO",
    name: "College of Massage Therapists of Ontario",
    registerUrlTemplate: null,
    searchUrl: "https://cmto.ca.thentiacloud.net/webs/cmto/register/",
    enabled: true,
  },
  {
    code: "CRPO",
    name: "College of Registered Psychotherapists and Registered Mental Health Therapists of Ontario",
    registerUrlTemplate: null,
    searchUrl: "https://my.crpo.ca/",
    enabled: true,
  },
  {
    code: "CPBAO",
    name: "College of Psychologists and Behaviour Analysts of Ontario",
    registerUrlTemplate: null,
    searchUrl: "https://members.cpbao.ca/public_register/new",
    enabled: true,
  },
  {
    code: "CRTO",
    name: "College of Respiratory Therapists of Ontario",
    registerUrlTemplate: null,
    searchUrl: "https://members.crto.on.ca/crto/CRTO/PublicDirectory/Public_Directory_Member/Public_Register/PublicRegisterMember.aspx",
    enabled: true,
  },
  {
    code: "COKO",
    name: "College of Kinesiologists of Ontario",
    registerUrlTemplate: null,
    searchUrl: "https://registrants.coko.ca/Shared_Content/Public_Registry/Multi_Search.aspx",
    enabled: true,
  },
  {
    code: "CCOO",
    name: "College of Chiropodists of Ontario",
    registerUrlTemplate: null,
    searchUrl: "https://registrants.cocoo.on.ca/Registrants/Registrants/Public_Registry/Extended_Search.aspx",
    enabled: true,
  },
  {
    code: "CCO",
    name: "College of Chiropractors of Ontario",
    registerUrlTemplate: null,
    searchUrl: "https://cco.ca.thentiacloud.net/webs/cco/register/?t=1",
    enabled: true,
  },
  {
    code: "CMO",
    name: "College of Midwives of Ontario",
    registerUrlTemplate: null,
    searchUrl: "https://cmo.ca.thentiacloud.net/webs/cmo/register/",
    enabled: true,
  },
  {
    code: "COD",
    name: "College of Dietitians of Ontario",
    registerUrlTemplate: null,
    searchUrl: "https://search.collegeofdietitians.org/home",
    enabled: true,
  },
  {
    code: "CONO",
    name: "College of Naturopaths of Ontario",
    registerUrlTemplate: null,
    searchUrl: "https://cono.alinityapp.com/client/publicdirectory",
    enabled: true,
  },
  {
    code: "COHO",
    name: "College of Homeopaths of Ontario",
    registerUrlTemplate: null,
    searchUrl: "https://app.collegeofhomeopaths.com/en/public/dashboard",
    enabled: true,
  },
  {
    code: "CASLPO",
    name: "College of Audiologists and Speech-Language Pathologists of Ontario",
    registerUrlTemplate: null,
    searchUrl: "https://publicregister.caslpo.com/",
    enabled: true,
  },
  {
    code: "CDTO",
    name: "College of Dental Technologists of Ontario",
    registerUrlTemplate: null,
    searchUrl: "https://cdto.ca.thentiacloud.net/webs/cdto/register/",
    enabled: true,
  },
  {
    code: "CMLTO",
    name: "College of Medical Laboratory Technologists of Ontario",
    registerUrlTemplate: null,
    searchUrl: "https://register.cmlto.com/PublicRegister/CMLTOPublicRegister/MLT-Search.aspx",
    enabled: true,
  },
  {
    code: "CMRITO",
    name: "College of Medical Radiation and Imaging Technologists of Ontario",
    registerUrlTemplate: null,
    searchUrl: "https://www.cmrito.org/public-register/",
    enabled: true,
  },
  {
    code: "COO",
    name: "College of Opticians of Ontario",
    registerUrlTemplate: null,
    searchUrl: "https://members.collegeofopticians.ca/coo/Public%20Register/Member-Search.aspx",
    enabled: true,
  },
  {
    code: "COOPT",
    name: "College of Optometrists of Ontario",
    registerUrlTemplate: null,
    searchUrl: "https://members.collegeoptom.on.ca/COO/PublicDirectory/Public_Directory_Member/Public_Register/PublicRegisterMember.aspx",
    enabled: true,
  },
  {
    code: "CTCMPAO",
    name: "College of Traditional Chinese Medicine Practitioners and Acupuncturists of Ontario",
    registerUrlTemplate: null,
    searchUrl: "https://www.ctcmpao.on.ca/publicregistersrc/",
    enabled: true,
  },
];

export const getCollege = (code) =>
  ONTARIO_COLLEGES.find((college) => college.code === code) || null;

export const getRegisterUrl = (code, number) => {
  const college = getCollege(code);
  if (!college) return null;
  if (!college.registerUrlTemplate) return college.searchUrl;
  return college.registerUrlTemplate.replace(
    "{number}",
    encodeURIComponent(number)
  );
};
